import { formatDate } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-office-representativewise',
  templateUrl: './office-representativewise.component.html',
  styleUrls: ['./office-representativewise.component.scss'],
})
export class OfficeRepresentativewiseComponent implements OnInit {
  offrepwiseData;
  today = new Date();
  startDate = '';
  endDate = '';
  isLoading: boolean = false;
  subTypesName = [
    { name: 'वार्षिक', isVisible: false },
    { name: 'त्रैवार्षिक', isVisible: false },
    { name: 'पंचवार्षिक', isVisible: false },
  ];
  totalth = 0;
  finalData = [];
  off_rep_name;
  appliedFilters: any = {};

  constructor(
    public dialogref: MatDialogRef<OfficeRepresentativewiseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.offrepwiseData = this.data['offrepwisedata'];
    this.off_rep_name = this.data['off_rep_name'];
    this.startDate = this.data['startDate'];
    this.endDate = this.data['endDate'];
    // console.log(this.offrepwiseData);
    
   this.appliedFilters = this.data['appliedFilters'] || {};

		console.log("Applied Filters:", this.appliedFilters);

    let data = this.uniqueData(this.offrepwiseData, (a) => a.subscription_type);

    for (let i = 0; i < Object.keys(data).length; i++) {
      let flag = false;
      for (let j = 0; j < Object.keys(this.subTypesName).length; j++) {
        if (data[i]['subscription_type'] === this.subTypesName[j]['name']) {
          this.subTypesName[j]['isVisible'] = true;
          flag = true;
          break;
        }
      }
      if (!flag) {
        // if (
        //   data[i]['Subscription_Type'] !== 'हितचिंतक सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'सप्रेम भेट - संपादकीय विभाग' ||
        //   data[i]['Subscription_Type'] !== 'जाहिरात स. भेट' ||
        //   data[i]['Subscription_Type'] !== 'संघ परिवार सप्रेम भेट' ||
        //   data[i]['Subscription_Type'] !== 'वर्गणी सप्रेम भेट'
        // ) {
        this.subTypesName.push({
          name: data[i]['subscription_type'],
          isVisible: true,
        });
        // }
      }
    }

    // console.log(this.subTypesName);
    // this.totalth = this.subTypesName.length * 4 + 8;

     this.totalth = this.subTypesName.filter(b => b.isVisible).length * 4 + 8;

    // this.getoffdata();
    this.setData();
  }


// getDistrictGroups(repData: any[]): any[] {
//   if (!Array.isArray(repData)) return [];

//   const districtMap = new Map();

//   for (const row of repData) {
//     const dist = row['rep_district'] || 'Unknown';

//     if (!districtMap.has(dist)) {
//       districtMap.set(dist, { rows: [], total: null });
//     }

//     districtMap.get(dist).rows.push(row);
//   }

//   // Add district-wise subtotals
//   districtMap.forEach((value, key) => {
//     const total = { ...value.rows[0] };
//     total.name = 'एकूण';

//     ['sub', 'एकूण', 'नवीन', 'नूतनीकरण', 'नूतनीकरणबाकी'].forEach(field => {
//       total[field] = value.rows.reduce((sum, r) => sum + (r[field] || 0), 0);
//     });

//     this.subTypesName.forEach(sub => {
//       if (sub.isVisible) {
//         const keyName = this.getKey(sub.name);
//         ['_नवीन', '_नूतनीकरण', '_एकूण', '_नूतनीकरणबाकी'].forEach(suffix => {
//           const fullKey = keyName + suffix;
//           total[fullKey] = value.rows.reduce((sum, r) => sum + (r[fullKey] || 0), 0);
//         });
//       }
//     });

//     value.total = total;
//   });

//   return Array.from(districtMap.values());
// }

getDistrictGroups(repData: any[]): any[] {

  if (!Array.isArray(repData)) return [];

  const map = new Map();

  for (const row of repData) {

    if (row.isOfficeRepTotal) continue;

    const dist = row.rep_district || 'Unknown';

    if (!map.has(dist)) {
      map.set(dist, { rows: [], total: null });
    }

    map.get(dist).rows.push(row);
  }

  map.forEach((value) => {

    const total = {};

    value.rows.forEach(r => {

      Object.keys(r).forEach(k => {
        if (typeof r[k] === 'number') {
          total[k] = (total[k] || 0) + r[k];
        }
      });

    });

    total['name'] = 'एकूण';
    total['rep_district'] = value.rows[0].rep_district;

    value.total = total;
  });

  return Array.from(map.values());
}

// Old Correct Code 
// setData() {

//   const finalTotal: any = {};

//   this.subTypesName.forEach((b: any, i) => {

//     if (b.isVisible) {

//       const name = this.getKey(b.name);

//       finalTotal[name + '_एकूण'] = 0;
//       finalTotal[name + '_नवीन'] = 0;
//       finalTotal[name + '_नूतनीकरण'] = 0;
//       finalTotal[name + '_नूतनीकरणबाकी'] = 0;

//       if (i === 0) {

//         finalTotal['name'] = 'एकूण';
//         finalTotal['sub'] = 0;

//         // ✅ MAIN TOTAL AMOUNT COLUMN
//         finalTotal['एकूण'] = 0;

//         finalTotal['नवीन'] = 0;
//         finalTotal['नूतनीकरण'] = 0;
//         finalTotal['नूतनीकरणबाकी'] = 0;
//       }
//     }
//   });

//   this.finalData = [];

//   const seniorityOrder = [
//     'दयानंद शिवशिवकर',
//     'प्रदीप निकम',
//     'धनाजी जाधव',
//     'राजेश गावडे',
//     'संजय शिवगण',
//     'कार्यालय-वर्गणी विक्री विभाग'
//   ];

//   let uniqueOfficeReps = this.uniqueData(
//     this.offrepwiseData,
//     (a: any) => a.office_rep_name
//   ) as any[];

//   uniqueOfficeReps.sort((a: any, b: any) => {

//     const ai = seniorityOrder.indexOf(a?.office_rep_name);
//     const bi = seniorityOrder.indexOf(b?.office_rep_name);

//     return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
//   });

//   for (const officeRep of uniqueOfficeReps as any[]) {

//     const officeRepData = (this.offrepwiseData as any[]).filter(
//       (a: any) => a?.office_rep_name === officeRep?.office_rep_name
//     );

//     const repDataGroup: any[] = [];

//     const uniqueReps = this.uniqueData(
//       officeRepData,
//       (a: any) => a.rep_name
//     ) as any[];

//     for (const rep of uniqueReps as any[]) {

//       const repRecords = officeRepData.filter(
//         (a: any) => a?.rep_name === rep?.rep_name
//       );

//       const uniqueDistricts = this.uniqueData(
//         repRecords,
//         (a: any) => a.rep_district
//       ) as any[];

//       for (const dist of uniqueDistricts as any[]) {

//         const districtwiseData = repRecords.filter(
//           (a: any) => a?.rep_district === dist?.rep_district
//         );

//         if (!districtwiseData.length) continue;

//         const subTotal: any = {
//           name: 'एकूण',
//           sub: 0,

//           // ✅ THIS IS MAIN "रक्कम" COLUMN
//           एकूण: 0,

//           नवीन: 0,
//           नूतनीकरण: 0,
//           नूतनीकरणबाकी: 0,
//           ...districtwiseData[0]
//         };

//         this.subTypesName.forEach((b: any) => {

//           if (!b.isVisible) return;

//           const name = this.getKey(b.name);

//           subTotal[name + '_एकूण'] = 0;
//           subTotal[name + '_नवीन'] = 0;
//           subTotal[name + '_नूतनीकरण'] = 0;
//           subTotal[name + '_नूतनीकरणबाकी'] = 0;
//         });

//         const today = new Date();
//         today.setMonth(today.getMonth() + 1);

//         for (const record of districtwiseData as any[]) {

//           const key = this.getKey(record?.subscription_type);

//           const isFuture =
//             new Date(record?.sub_perid_to_date) > today;

//           const amt = Number(record?.total_amt || 0);

//           subTotal.sub++;
//           finalTotal.sub++;

//           // ✅ IMPORTANT FIX
//           // ALWAYS ADD ALL RECORD AMOUNTS IN MAIN "एकूण" COLUMN
//           subTotal['एकूण'] =
//             Number(subTotal['एकूण'] || 0) + amt;

//           finalTotal['एकूण'] =
//             Number(finalTotal['एकूण'] || 0) + amt;

//           if (!key) {

//             if (isFuture) {

//               if (record?.rcpt_type === 'New') {

//                 subTotal['नवीन']++;
//                 finalTotal['नवीन']++;

//               } else {

//                 subTotal['नूतनीकरण']++;
//                 finalTotal['नूतनीकरण']++;
//               }

//             } else {

//               subTotal['नूतनीकरणबाकी']++;
//               finalTotal['नूतनीकरणबाकी']++;
//             }

//             continue;
//           }

//           // ✅ SUB TYPE AMOUNT
//           subTotal[key + '_एकूण'] =
//             Number(subTotal[key + '_एकूण'] || 0) + amt;

//           finalTotal[key + '_एकूण'] =
//             Number(finalTotal[key + '_एकूण'] || 0) + amt;

//           if (isFuture) {

//             if (record?.rcpt_type === 'New') {

//               subTotal[key + '_नवीन']++;
//               finalTotal[key + '_नवीन']++;

//               subTotal['नवीन']++;
//               finalTotal['नवीन']++;

//             } else {

//               subTotal[key + '_नूतनीकरण']++;
//               finalTotal[key + '_नूतनीकरण']++;

//               subTotal['नूतनीकरण']++;
//               finalTotal['नूतनीकरण']++;
//             }

//           } else {

//             subTotal[key + '_नूतनीकरणबाकी']++;
//             finalTotal[key + '_नूतनीकरणबाकी']++;

//             subTotal['नूतनीकरणबाकी']++;
//             finalTotal['नूतनीकरणबाकी']++;
//           }
//         }

//         subTotal.isDistrictSubtotal = true;

//         repDataGroup.push(subTotal);
//       }
//     }

//     const officeTotal = repDataGroup.reduce((acc: any, row: any) => {

//       Object.keys(row).forEach((k: any) => {

//         if (typeof row[k] === 'number') {

//           acc[k] = Number(acc[k] || 0) + Number(row[k] || 0);
//         }
//       });

//       return acc;

//     }, {
//       name: `${officeRep?.office_rep_name || ''} - एकूण`,
//       isOfficeRepTotal: true
//     });

//     repDataGroup.push(officeTotal);

//     this.finalData.push(repDataGroup);
//   }

//   this.finalData.push(finalTotal);

//   this.isLoading = false;
// }

setData() {

  const finalTotal: any = {

    // ✅ IMPORTANT FIX
    // ALWAYS INITIALIZE DEFAULT VALUES
    name: 'एकूण',
    sub: 0,

    'एकूण': 0,
    'नवीन': 0,
    'नूतनीकरण': 0,
    'नूतनीकरणबाकी': 0,

    // ✅ FLAG FOR HTML
    isFinalTotal: true
  };

  // ✅ INITIALIZE SUBTYPE TOTALS
  this.subTypesName.forEach((b: any) => {

    if (b.isVisible) {

      const name = this.getKey(b.name);

      finalTotal[name + '_एकूण'] = 0;
      finalTotal[name + '_नवीन'] = 0;
      finalTotal[name + '_नूतनीकरण'] = 0;
      finalTotal[name + '_नूतनीकरणबाकी'] = 0;
    }
  });

  this.finalData = [];

  const seniorityOrder = [
    'दयानंद शिवशिवकर',
    'प्रदीप निकम',
    'धनाजी जाधव',
    'राजेश गावडे',
    'संजय शिवगण',
    'कार्यालय-वर्गणी विक्री विभाग'
  ];

  let uniqueOfficeReps = this.uniqueData(
    this.offrepwiseData,
    (a: any) => a.office_rep_name
  ) as any[];

  uniqueOfficeReps.sort((a: any, b: any) => {

    const ai = seniorityOrder.indexOf(a?.office_rep_name);
    const bi = seniorityOrder.indexOf(b?.office_rep_name);

    return (ai === -1 ? 999 : ai) - (bi === -1 ? 999 : bi);
  });

  for (const officeRep of uniqueOfficeReps as any[]) {

    const officeRepData = (this.offrepwiseData as any[]).filter(
      (a: any) => a?.office_rep_name === officeRep?.office_rep_name
    );

    const repDataGroup: any[] = [];

    const uniqueReps = this.uniqueData(
      officeRepData,
      (a: any) => a.rep_name
    ) as any[];

    for (const rep of uniqueReps as any[]) {

      const repRecords = officeRepData.filter(
        (a: any) => a?.rep_name === rep?.rep_name
      );

      const uniqueDistricts = this.uniqueData(
        repRecords,
        (a: any) => a.rep_district
      ) as any[];

      for (const dist of uniqueDistricts as any[]) {

        const districtwiseData = repRecords.filter(
          (a: any) => a?.rep_district === dist?.rep_district
        );

        if (!districtwiseData.length) continue;

        const subTotal: any = {
          name: 'एकूण',
          sub: 0,

          // ✅ MAIN TOTAL AMOUNT COLUMN
          'एकूण': 0,

          'नवीन': 0,
          'नूतनीकरण': 0,
          'नूतनीकरणबाकी': 0,

          ...districtwiseData[0]
        };

        this.subTypesName.forEach((b: any) => {

          if (!b.isVisible) return;

          const name = this.getKey(b.name);

          subTotal[name + '_एकूण'] = 0;
          subTotal[name + '_नवीन'] = 0;
          subTotal[name + '_नूतनीकरण'] = 0;
          subTotal[name + '_नूतनीकरणबाकी'] = 0;
        });

        const today = new Date();
        today.setMonth(today.getMonth() + 1);

        for (const record of districtwiseData as any[]) {

          const key = this.getKey(record?.subscription_type);

          const isFuture =
            new Date(record?.sub_perid_to_date) > today;

          const amt = Number(record?.total_amt || 0);

          subTotal.sub++;
          finalTotal.sub++;

          // ✅ MAIN AMOUNT TOTAL
          subTotal['एकूण'] =
            Number(subTotal['एकूण'] || 0) + amt;

          finalTotal['एकूण'] =
            Number(finalTotal['एकूण'] || 0) + amt;

          // ✅ IF KEY NOT FOUND
          if (!key) {

            if (isFuture) {

              if (record?.rcpt_type === 'New') {

                subTotal['नवीन']++;
                finalTotal['नवीन']++;

              } else {

                subTotal['नूतनीकरण']++;
                finalTotal['नूतनीकरण']++;
              }

            } else {

              subTotal['नूतनीकरणबाकी']++;
              finalTotal['नूतनीकरणबाकी']++;
            }

            continue;
          }

          // ✅ SUBTYPE AMOUNT
          subTotal[key + '_एकूण'] =
            Number(subTotal[key + '_एकूण'] || 0) + amt;

          finalTotal[key + '_एकूण'] =
            Number(finalTotal[key + '_एकूण'] || 0) + amt;

          if (isFuture) {

            if (record?.rcpt_type === 'New') {

              subTotal[key + '_नवीन']++;
              finalTotal[key + '_नवीन']++;

              subTotal['नवीन']++;
              finalTotal['नवीन']++;

            } else {

              subTotal[key + '_नूतनीकरण']++;
              finalTotal[key + '_नूतनीकरण']++;

              subTotal['नूतनीकरण']++;
              finalTotal['नूतनीकरण']++;
            }

          } else {

            subTotal[key + '_नूतनीकरणबाकी']++;
            finalTotal[key + '_नूतनीकरणबाकी']++;

            subTotal['नूतनीकरणबाकी']++;
            finalTotal['नूतनीकरणबाकी']++;
          }
        }

        subTotal.isDistrictSubtotal = true;

        repDataGroup.push(subTotal);
      }
    }

    // ✅ OFFICE TOTAL
    const officeTotal = repDataGroup.reduce((acc: any, row: any) => {

      Object.keys(row).forEach((k: any) => {

        if (typeof row[k] === 'number') {

          acc[k] =
            Number(acc[k] || 0) +
            Number(row[k] || 0);
        }
      });

      return acc;

    }, {
      name: `${officeRep?.office_rep_name || ''} - एकूण`,
      isOfficeRepTotal: true
    });

    repDataGroup.push(officeTotal);

    this.finalData.push(repDataGroup);
  }

  // ✅ IMPORTANT FIX
  // MAY MONTH ISSUE SOLVED
  // PUSH FINAL TOTAL AS ARRAY
  // SAME STRUCTURE AS OTHER GROUPS

  this.finalData.push(finalTotal);

  console.log(this.finalData);

  this.isLoading = false;
}

createEmptyTotal(ref: any): any {
  const total: any = {
    name: 'एकूण',
    district_name: ref.district_name,
    office_rep_name: ref.office_rep_name,
    sub: 0, 'एकूण': 0, 'नवीन': 0, 'नूतनीकरण': 0, 'नूतनीकरणबाकी': 0
  };

  this.subTypesName.forEach(sub => {
    if (sub.isVisible) {
      const key = this.getKey(sub.name);
      total[key + '_नवीन'] = 0;
      total[key + '_नूतनीकरण'] = 0;
      total[key + '_एकूण'] = 0;
      total[key + '_नूतनीकरणबाकी'] = 0;
    }
  });

  return total;
}

addToTotal(total: any, record: any): void {
  total.sub += record.sub || 0;
  total['एकूण'] += record['एकूण'] || 0;
  total['नवीन'] += record['नवीन'] || 0;
  total['नूतनीकरण'] += record['नूतनीकरण'] || 0;
  total['नूतनीकरणबाकी'] += record['नूतनीकरणबाकी'] || 0;

  this.subTypesName.forEach(sub => {
    if (sub.isVisible) {
      const key = this.getKey(sub.name);
      total[key + '_नवीन'] += record[key + '_नवीन'] || 0;
      total[key + '_नूतनीकरण'] += record[key + '_नूतनीकरण'] || 0;
      total[key + '_एकूण'] += record[key + '_एकूण'] || 0;
      total[key + '_नूतनीकरणबाकी'] += record[key + '_नूतनीकरणबाकी'] || 0;
    }
  });
}


  getKey(name) {
    return name.replaceAll(' ', '_');
  }

  uniqueData(data, key) {
    return [...new Map(data.map((a) => [key(a), a])).values()];
  }

  exportExcel(fileName) {
    /* table id is passed over here */
    let element = document.getElementById('print-section');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, fileName + '.xlsx');
  }


  //Main Report Method Use in all Printing Page
  show = false
  printPage() {
    this.show = true
    const printContent = document.getElementById('print-section')?.outerHTML;
    if (!printContent) {
      console.error("Print section not found!");
      return;
    }

    const printWindow = window.open('', '', 'width=1400,height=1000,top=50,left=50,scrollbars=yes');

    if (printWindow) {
      printWindow.document.open();
      printWindow.document.write(`
             <html>
                 <head>
                     <title>Print Report</title>
                     <style>
                         @media print {
                             @page { 
                                 size: A3 landscape; /* Set A3 size with landscape mode */
                                 margin: 5mm; /* Adjust margins */
                             }
                             body { 
                                 font-family: Arial, sans-serif; 
                                 font-size: 15px; /* Adjust font size */
                                 margin: 0; 
                                 padding: 5mm; 
                                 line-height: 1.2; 
                             }
                             table { 
                                 width: 100%; 
                                 height: auto !important;
                                 border-collapse: collapse; 
                                 table-layout: fixed; /* Prevent column expansion */
                                 page-break-inside: avoid; /* Avoid breaking the table */
                             }
                             th, td { 
                                 padding: 2px; 
                                 border: 1px solid black; 
                                 text-align: center; 
                                 font-size: 12px; /* Adjusted font size */
                                 line-height: 1.2; 
                             }
                             .noPrint { 
                                 display: none; /* Hide print button */
                             }
                         }
                     </style>
                 </head>
                 <body>
                     <div id="print-section">
                         ${printContent}
                     </div>
                     <script>
                         window.onload = function() { 
                             window.print(); 
                             setTimeout(() => { window.close(); }, 500);
                         };
                     </script>
                 </body>
             </html>
         `);
      printWindow.document.close();
    } else {
      console.error("Failed to open print window.");
    }
  }

}

